import * as RoutingNS from '../Routing/EpiSpaRouter.js';
import IRouteConfigBase, { IRouteConfigItem as IRouteConfigItemBase, IRouteConfigComponentProps as IRouteConfigComponentPropsBase } from '../Routing/IRouteConfig.js';

/**
 * Routing capability
 */
export const Router = RoutingNS.Router;
export const Content = RoutingNS.RoutedContent;
export type RouterProps = RoutingNS.RouterProps;
export type ContentProps = RoutingNS.RoutedContentProps;
export type IRoutingConfig = IRouteConfigBase;
export type IRoutingItem   = IRouteConfigItemBase;
export type RoutedComponentProps<T extends { [K in keyof T]?: string | undefined; }> = IRouteConfigComponentPropsBase<T>;